"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M33.072 31.759L24 14V4h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v10L2.928 31.759A3 3 0 0 0 5.659 36h24.682a3 3 0 0 0 2.731-4.241zM8.727 24.364L14 14.454V4h8v10.455l2.636 4.909z" })
);

